<template>
  <section class="reply-refer-form">
    <el-form
      ref="form"
      :model="item"
      :rules="formRules">
      <div v-show="item.quote_status == 0 && editType == 3">
        <div class="flex-sb">
          <div class="form-item form-half">
            <span>Insurer Quote Status</span>
            <el-form-item
              ref="quote_status"
              prop="quote_status">
              <v-radio-group
                v-model="item.quote_status"
                :border="true"
                :list="quoteStatusOptions" />
            </el-form-item>
          </div>
        </div>
        <div class="box">
          <div class="form-item form-half">
            <span>Insurer</span>
            {{item.company_id}}
            <el-form-item
              ref="company_id"
              prop="company_id">
              <v-select
                v-model="item.company_id"
                :list="localAllOptions.insurer"
                :disabled="editType == 3 && index == 0"
                @change="()=>(formDataLock+=1)" />
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Class of Insurance</span>
            <el-form-item>
              <v-select
                v-model="item.plan_id"
                :list="currentPlanOptions"
                :disabled="showBuyable || (editType == 3 && index == 0)"
                @change="changePlan" />
            </el-form-item>
          </div>
          <div
            v-if="item.quote_status==0"
            class="form-item form-half">
            <span>Reject Renewal Notice</span>
            <el-form-item
              ref="renew_file_path_id"
              prop="renew_file_path_id">
              <v-upload
                card
                widthFull
                :fileData="reject_fileData[index]"
                :otherData="otherData"
                @delete="handleDel"
                @uploadSuccess="handlerUploadSuccess" />
            </el-form-item>
          </div>
        </div>
      </div>
      <div v-show="(item.quote_status != 0 && editType == 3) || editType != 3">
        <div class="flex-sb">
          <div class="form-item form-half">
            <span>Insurer Quote Status</span>
            <el-form-item
              ref="quote_status"
              prop="quote_status">
              <v-radio-group
                v-model="item.quote_status"
                :border="true"
                :disabled="showBuyable || editType == 2"
                :list="quoteStatusOptions" />
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Total Payable</span>
            <span>{{ item.payable }}</span>
          </div>
        </div>
        <div class="box">
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Insurer</span>
              <el-form-item
                ref="company_id"
                prop="company_id">
                <v-select
                  v-model="item.company_id"
                  :list="localAllOptions.insurer"
                  :disabled="showBuyable || (editType == 3 && index == 0)"
                  @change="changeCompany" />
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Type of Insurance</span>
              <v-select
                v-model="item.class_id"
                :disabled="true"
                :list="classOptions" />
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Class of Insurance</span>
              <el-form-item
                ref="plan_id"
                prop="plan_id">
                <v-select
                  v-model="item.plan_id"
                  :disabled="showBuyable || (editType == 3 && index == 0)"
                  :list="currentPlanOptions"
                  @change="changePlan"/>
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Policyholder</span>
              <v-input
                v-model="item.isrd_nm"
                :disabled="true" />
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Quotation Number</span>
              <v-input
                v-model="item.quote_no"
                :disabled="true" />
            </div>
            <div class="form-item form-half">
              <span>Type of quotation</span>
              <v-select
                v-model="item.type"
                :disabled="true"
                :list="globalOptions.quote_type" />
            </div>
          </div>
          <div
            class="flex-sb">
            <div class="form-item form-half">
              <span>Expected Effective date</span>
              <el-form-item
                ref="pcy_cmnt_dt"
                prop="pcy_cmnt_dt">
                <v-date-picker
                  v-model="item.pcy_cmnt_dt"
                  :disabled="showBuyable || Boolean(item.pcy_cmnt_dt)"/>
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Expected Expiry Date</span>
              <el-form-item
                ref="pcy_expry_dt"
                prop="pcy_expry_dt">
                <v-date-picker
                  v-model="item.pcy_expry_dt"
                  :disabled="showBuyable || item.pcy_expry_dt != ''"/>
              </el-form-item>
            </div>
          </div>
        </div>

        <div class="box">
          <h3>Coverage</h3>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Home Contents Cover</span>
              <v-input
                v-model="item.contents_cover"
                :keyNumber="true"
                :int="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
            <div class="form-item form-half">
              <span>Public Liability Cover</span>
              <v-input
                v-model="item.personal_liability_cover"
                :keyNumber="true"
                :int="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Additional Accommodation Expense</span>
              <v-input
                v-model="item.additional_accommodation_exp"
                :keyNumber="true"
                :int="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
            <div class="form-item form-half">
              <span>Personal Guard</span>
              <v-input
                v-model="item.personal_guard"
                :keyNumber="true"
                :int="true"
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Building Structure Coverage Sum Insured</span>
              <template v-if="item.company_id == 15">
                <v-input
                  value="Reinstatement cost ( remark : MAX 20,000,000)"
                  disabled></v-input>
              </template>
              <template v-else>
                <el-form-item
                  ref="bsc_rider_cover"
                >
                  <v-input
                    v-model="item.bsc_rider_cover"
                    :keyNumber="true"
                    :int="true"
                    maxlength="9"
                    :disabled="showBuyable"
                    append="HK$" />
                </el-form-item>
              </template>
            </div>
          </div>
          <div
            v-if="plan_cvr_remark"
            class="form-item">
            <span>Plan Coverage Remark</span>
            <span>{{plan_cvr_remark}}</span>
          </div>
          <div class="flex-sb">
            <div class="form-half">
              <div class="form-item">
                <span>Coverage Remark</span>
                <v-input
                  v-model="item.cvr_remark"
                  type="textarea"
                  :rows="3"
                />
              </div>
            </div>
          </div>
        </div>

        <!--      <div class="box">-->
        <!--        <span class="title">More Benefits</span>-->
        <!--        <div class="form-item">-->
        <!--          <v-checkbox-group-->
        <!--            v-model="item.benefits"-->
        <!--            :block="true"-->
        <!--            :disabled="showBuyable"-->
        <!--            :list="localAllOptions.benefits">-->
        <!--          &lt;!&ndash; <template v-slot:input="input">-->
        <!--            <v-input v-model="item.benefit_coverage[input.id]" />-->
        <!--          </template> &ndash;&gt;-->
        <!--          </v-checkbox-group>-->
        <!--        </div>-->
        <!--      </div>-->
        <benefit-form
          ref="benefit-form"
          :form="item"
          :disabled="showBuyable"
          :editType="editType"
          :renewOrderId="renewOrderId"
          :classId="item.class_id"
          :formDataLock="excessFormDataLock"
          @getFormData="getSubFormData"
          @getSubmitPremium="getSubmitPremium"
        />
        <!-- <div
        v-for="(excessItem, excessIndex) in item.excess"
        :key="excessIndex"
        class="box">
        <h3>{{ excessItem.title }}</h3>
        <div
          v-for="(item, index) in excessItem.items"
          :key="index">
          <div class="form-item">
            <span>{{ item.label }}</span>
            <div class="flex-sb">
              <template v-if="item.sp_sn === 1">
                <div
                  v-if="item.field_1"
                  class="form-half-3">
                  <v-input
                    v-model="item.value_1"
                    prepend="$" />
                </div>
                <div
                  v-if="item.field_2"
                  class="form-half-3">
                  <v-input
                    v-model="item.value_2"
                    prepend="$" />
                </div>
                <div
                  v-if="item.field_3"
                  class="form-half-3">
                  <v-input
                    v-model="item.value_3"
                    prepend="$" />
                </div>
              </template>
              <template v-else>
                <div
                  v-if="item.field_1"
                  class="form-half">
                  <v-input
                    v-model="item.value_1"
                    prepend="$" />
                </div>
                <div
                  v-if="item.field_2"
                  class="form-half">
                  <v-input
                    v-model="item.value_2"
                    append="%" />
                </div>
              </template>

            </div>
          </div>
        </div>
      </div> -->
        <homefire-excess-form
          ref="homefire-excess-form"
          :excess="item.excess"
          :referId="referId"
          :form="item"
          :disabled="showBuyable"
          :editType="editType"
          :renewOrderId="renewOrderId"
          :formDataLock="excessFormDataLock"
          @getFormData="getExcessFormData" />

        <div class="form-item form-half">
          <span>Excess Remark</span>
          <v-input
            v-model="item.remark "
            type="textarea"
            :disabled="showBuyable"
            :rows="4" />
        </div>


        <div class="box">
          <h3>Remarks</h3>
          <div class="form-item form-half">
            <span>Policy Remark</span>
            <v-input
              v-model="item.cs_manual_remark"
              type="textarea"
              :disabled="showBuyable"
              :rows="4" />
          </div>
        </div>
        <div class="box">
          <refer-underwriting
            ref="refer-underwriting"
            :form="item"
            :classId="item.class_id"
            :disabled="showBuyable"
            :editType="editType"
            :renewOrderId="renewOrderId"
            :formDataLock="excessFormDataLock"
            @sendPlanCvrRemark="getPlanCvrRemark"
            @getSubmitPremium="getSubmitPremium"
            @getFormData="getSubFormData" />
            <!--        <h3>Underwriting Question</h3>-->
            <!--        <div class="flex-sb-wrap">-->
            <!--          <div-->
            <!--            v-for="(inItem, inIndex) in item.underwriting"-->
            <!--            :key="inIndex"-->
            <!--            class="form-item form-half">-->
            <!--            <span>{{ inItem.name }}</span>-->
            <!--            <v-radio-group-->
            <!--              v-model="inItem.answer"-->
            <!--              :border="true"-->
            <!--              :disabled="showBuyable"-->
            <!--              :list="yesNoOptions" />-->
            <!--          </div>-->
            <!--        </div>-->
        </div>


        <!--      <div class="box">-->
        <!--        <h3>Premium</h3>-->
        <!--        <div class="form-half">-->
        <!--          <div class="table">-->
        <!--            <div class="tr th">-->
        <!--              <span>Item</span>-->
        <!--              <span>Amount</span>-->
        <!--            </div>-->
        <!--            <div class="tr">-->
        <!--              <span>-->
        <!--                Basic Premium-->
        <!--                <el-form-item-->
        <!--                  ref="basic_prm"-->
        <!--                  prop="basic_prm">-->
        <!--                  <v-input-->
        <!--                    v-model="item.basic_prm"-->
        <!--                    append="HKD" />-->
        <!--                </el-form-item>-->
        <!--              </span>-->
        <!--              <span>{{ item.basic_prm | formatMoney(2, true) }}</span>-->
        <!--            </div>-->
        <!--            <div class="tr">-->
        <!--              <span>-->
        <!--                MGM Discount-->
        <!--                <el-form-item-->
        <!--                  ref="code_disc_pct"-->
        <!--                  prop="code_disc_pct">-->
        <!--                  <v-input-->
        <!--                    v-model="item.code_disc_pct"-->
        <!--                    append="%" />-->
        <!--                </el-form-item>-->
        <!--              </span>-->
        <!--              <span>{{ item.code_disc_prm | formatMoney(2, true) }}</span>-->
        <!--            </div>-->
        <!--            <div class="tr">-->
        <!--              <span>-->
        <!--                Levy-->
        <!--                <el-form-item-->
        <!--                  ref="ia_levy_pct"-->
        <!--                  prop="ia_levy_pct">-->
        <!--                  <v-input-->
        <!--                    v-model="item.ia_levy_pct"-->
        <!--                    append="%" />-->
        <!--                </el-form-item>-->
        <!--              </span>-->
        <!--              <span>{{ item.ia_levy_vl | formatMoney(2, true) }}</span>-->
        <!--            </div>-->
        <!--            <div class="tr">-->
        <!--              <span>-->
        <!--                Manual Discount-->
        <!--                <el-form-item-->
        <!--                  ref="spec_disc_prm"-->
        <!--                  prop="spec_disc_prm">-->
        <!--                  <v-input-->
        <!--                    v-model="item.spec_disc_prm"-->
        <!--                    append="HKD" />-->
        <!--                </el-form-item>-->
        <!--              </span>-->
        <!--              <span>{{ item.spec_disc_prm | formatMoney(2, true) }}</span>-->
        <!--            </div>-->
        <!--            <div class="tr">-->
        <!--              <span>-->
        <!--                Admin Charge-->
        <!--                <el-form-item-->
        <!--                  ref="handling_fee"-->
        <!--                  prop="handling_fee">-->
        <!--                  <v-input-->
        <!--                    v-model="item.handling_fee"-->
        <!--                    prepend="$"-->
        <!--                    @blur="handlerReferralMain" />-->
        <!--                </el-form-item>-->
        <!--              </span>-->
        <!--              <span>{{ item.handling_fee | formatMoney(2, true) }}</span>-->
        <!--            </div>-->
        <!--            <div class="tr">-->
        <!--              <span>-->
        <!--                Total Payable-->
        <!--              </span>-->
        <!--              <span>{{ item.payable | formatMoney(2, true) }}</span>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </div>-->
        <premium-form
          ref="premium"
          :classId="item.class_id"
          :form="item"
          :benefitList="benefitList"
          :disabled="showBuyable"
          :editType="editType"
          :renewOrderId="renewOrderId"
          :customerId="customerId"
          :formDataLock="excessFormDataLock"
          @submitPremium="submitPremium"
          @getSubmitPremium="getSubmitPremium"
        ></premium-form>
      </div>

    </el-form>
  </section>
</template>
<script>
import MixinRules from '@/mixins/rules'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import HomefireExcessForm from '@/views/tickets/components/modules/homefire/homefire-excess-form'
import {getReferralHomeExcess} from '@/api/refer'
import PremiumForm from '@/views/components/premium-form'
import benefitForm from '@/views/tickets/components/modules/component/more-benefit'
import referUnderwriting from '@/views/tickets/components/form/refer-underwriting'

export default {
  name: 'HomefireReplyReferForm',
  components: {
    HomefireExcessForm,
    PremiumForm,
    benefitForm,
    referUnderwriting
  },
  mixins: [MixinOptions, MixinRules, MixinFormat],
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    index: [String, Number],
    customerId: [String, Number],
    referId: [String, Number],
    showBuyable:{
      type:Boolean,
      default:false
    },
    editType: {
      type: Number,
      default: 1 // 1 - reply, 2 - upgrade, 3 - renew
    },
    renewOrderId:{
      type: [Number, String],
      default: null
    },
    reject_fileData:{
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      excessFormDataLock: 0, // 因爲 home fire excess 數據是動態的，所以需要動態鎖定表單
      parentOtherData: null,
      quoteStatusOptions: [
        {
          name: 'Quoted',
          id: 1
        },
        {
          name: 'Rejected',
          id: 0
        },
      ],
      subForm: {
        'premium':false,
        'benefit-form':false,
      },
      plan_cvr_remark: '',
      benefitList: [],
      otherData:{
        target: 'renew_file_path_id',
        index: this.index,
        name: 'homefire-reply-refer-form'
      }
    }
  },
  computed: {
    //basic_prm、code_disc_pct、ia_levy_pct、spec_disc_pct、handling_fee
    //quote_status = 0，reject 以上字段不用验证
    formRules() {
      const {quote_status} = this.item
      var rule = JSON.stringify(this.rules)
      const data =[
        'basic_prm',
        'code_disc_pct',
        'ia_levy_pct',
        'spec_disc_pct',
        'handling_fee',
        'pcy_expry_dt'
      ]
      rule = JSON.parse(rule)
      data.forEach(item=>{
        rule[item][0].required =false
      })
      return quote_status==0? rule:this.rules
    },
    localAllOptions() {
      return this.allOptions26
    },
    currentPlanOptions() {
      if(!this.globalOptions || !this.globalOptions.plan) {
        return []
      }
      const { class_id, company_id } = this.item
      const key = `${company_id}${class_id}`
      return this.globalOptions.plan.filter(item => item.category_id == key)
    }
  },
  watch: {
    'item.plan_id': {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          this.changePlan()
        }
      }
    },
    'item.quote_status':{
      immediate: true,
      deep: true,
      handler(val){
        if(val == 1){
          this.handleDel({otherData: this.otherData})
        }
      }
    }
  },
  methods: {
    handleDel(otherData){
      this.$emit('delete', otherData)
    },
    handlerUploadSuccess(uploadRsult){
      this.$emit('uploadSuccess',uploadRsult)
    },
    getSubFormData(form, data) {
      this.subForm[form] = true
      this.item = Object.assign(this.item, data)
    },
    submitPremium(form,data){
      this.subForm[form] = true
      Object.assign(this.item, data)
    },
    async validateForm(otherData) {
      Object.keys(this.subForm).some(key => {
        this.subForm[key] = false
        this.$refs[key].submitForm(key)
      })
      if (Object.values(this.subForm).some(item => item === false)) {
        return
      }
      await new Promise((resolve, reject) => {
        this.$refs['form'].validate((valid, rules) => {
          if(valid) {
            this.parentOtherData = otherData
            this.$refs['homefire-excess-form'].submitForm()
            // this.$emit('validate', otherData)
            resolve(valid)
          }
          else {
            this.scrollToValidDom(rules)
            reject(valid)
          }
        })
      })
    },
    getExcessFormData(data) {
      // this.$set(this.item, 'excess', data)
      Object.assign(this.item, data)
      this.$emit('validate', this.parentOtherData)
    },
    getSubmitPremium(data, index, name){
      if(name == 'benefit'){
        this.benefitList = []
        Object.assign(this.benefitList, data.benefits)
      }
      Object.assign(this.item, data)
      this.$forceUpdate()
    },
    getPlanCvrRemark(data){
      this.plan_cvr_remark = data
    },
    handlerReferralMain() {
      this.$emit('getPremium', this.index)
    },
    changeCompany() {
      this.excessFormDataLock += 1
      this.$set(this.item, 'plan_id', '')
    },
    changePlan() {
      this.excessFormDataLock += 1
      this.$emit('changePlan', this.currentPlanOptions)
    },
    planOptions() {
      const { class_id, company_id } = this.item
      if(!class_id || !company_id) return []

      const key = `${company_id}${class_id}`
      const { plan } = this.globalOptions
      const options = plan[key]
      if(!options) return []
      return options
    },
    network() {
      return {
        getReferralHomeExcess: async () => {
          const { data } = await getReferralHomeExcess({
            company_id: this.item.company_id,
            plan_id: this.item.plan_id,
            refer_id: this.referId,
            hideLoading: true
          })
          this.excessFormDataLock += 1
          this.$set(this.item, 'excess', data)
        }
      }
    }
  }
}
</script>
